import { z } from 'zod';
import { CoinTransactionDtoSchema, CoinTxReasonSchema, CoinTxStatusSchema } from './coin-tx';

// Query-параметры `GET /admin/coins/transactions`.
// `status` и `reason` — multi-select; controller'у проще принять массив
// (Nest сам парсит `?status=PENDING&status=POSTED`). Если фронт шлёт CSV,
// маппер на стороне controller'а разрежет до массива до парсинга.
export const AdminCoinTransactionsQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
  status: z.array(CoinTxStatusSchema).optional(),
  reason: z.array(CoinTxReasonSchema).optional(),
  userId: z.uuid().optional(),
});
export type AdminCoinTransactionsQuery = z.infer<typeof AdminCoinTransactionsQuerySchema>;

export const AdminCoinTransactionsResponseSchema = z.object({
  items: z.array(CoinTransactionDtoSchema),
  nextCursor: z.string().nullable(),
});
export type AdminCoinTransactionsResponse = z.infer<typeof AdminCoinTransactionsResponseSchema>;

// Тело `POST /admin/coins/adjust` — ручная корректировка баланса (reason
// MANUAL_ADJUST). Ровно одно из:
//   • `delta`  — прибавить/списать ±N (точно ложится на инкрементную модель воркера);
//   • `setTo`  — выставить баланс ровно в N (сервер сам посчитает delta = setTo − текущий).
// Границы [-1_000_000 … 1_000_000] — защита от случайного переполнения Int32
// и опечаток; для теста фронта с запасом. `note` попадает в metadata для аудита.
const ADJUST_BOUND = 1_000_000;
export const AdminAdjustCoinsRequestSchema = z
  .object({
    userId: z.uuid(),
    delta: z.number().int().min(-ADJUST_BOUND).max(ADJUST_BOUND).optional(),
    setTo: z.number().int().min(0).max(ADJUST_BOUND).optional(),
    note: z.string().max(280).optional(),
  })
  .refine((v) => (v.delta === undefined) !== (v.setTo === undefined), {
    message: 'Укажите ровно одно из delta|setTo',
    path: ['delta'],
  })
  .refine((v) => v.delta !== 0, {
    message: 'delta не может быть 0',
    path: ['delta'],
  });
export type AdminAdjustCoinsRequest = z.infer<typeof AdminAdjustCoinsRequestSchema>;

export const AdminAdjustCoinsResponseSchema = z.object({
  coinTxId: z.uuid(),
  userId: z.uuid(),
  delta: z.number().int(),
  status: CoinTxStatusSchema,
  idempotencyKey: z.string(),
});
export type AdminAdjustCoinsResponse = z.infer<typeof AdminAdjustCoinsResponseSchema>;
